module.exports = __webpack_public_path__ + "img/log.f74be847.svg";